var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import dayjs from "dayjs";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { renderIcon } from "../CommonFunctions";
import { Box, Grid, Link, Tooltip, Typography } from "@mui/material";
import { downloadAttachmentFfrAPI } from "../../services/apiCalls";
export var handleAttachmentDownload = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var request, res, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!value) return [3 /*break*/, 2];
                request = value;
                return [4 /*yield*/, downloadAttachmentFfrAPI({
                        request: request
                    })];
            case 1:
                res = _a.sent();
                url = URL.createObjectURL(res === null || res === void 0 ? void 0 : res.data);
                window.open(url, '_blank');
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export var AdditionalInfoMobileView = [{
        type: FormItemTypes.Typography,
        name: "title",
        fontSize: "md",
        fontWeight: "strong",
        children: "Courier details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Courier name',
                        filedName: 'CourierName'
                    }, {
                        label: 'Docket number',
                        filedName: 'DocketNumber'
                    }, {
                        label: 'Dispatch date',
                        filedName: 'DispatchDate'
                    }].map(function (item) { return ({
                    type: FormItemTypes.Typography,
                    name: item.filedName,
                    label: item.label,
                    value: '-',
                    fontSize: 'sm',
                    fontWeight: 'medium',
                    columnSize: 12,
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    containerProps: {
                        display: 'flex',
                        direction: 'row',
                        justifyContent: 'space-between'
                    },
                    valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                }); }), true)
            }]
    }, {
        type: FormItemTypes.ContainerItem,
        name: '',
        columnSize: 12,
        pt: 2,
        elements: [{
                type: FormItemTypes.List,
                columnSize: 12,
                variant: 'comfortable',
                name: 'Attachments',
                disableDetailsPanel: true,
                getRowHeight: function () { return 'auto'; },
                disableCheckboxSelection: true,
                value: null,
                columns: [{
                        field: 'ContentType',
                        flex: 1,
                        renderCell: function (_ref) {
                            var row = _ref.row;
                            return /*#__PURE__*/ React.createElement(Grid, {
                                container: true,
                                mt: 1,
                                spacing: 0
                            }, /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                xs: 12,
                                container: true,
                                spacing: 0
                            }, /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                xs: 1
                            }, /*#__PURE__*/ React.createElement(Box, {
                                p: 2,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: 30
                            }, renderIcon(row === null || row === void 0 ? void 0 : row.FileName))), /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                xs: 9
                            }, /*#__PURE__*/ React.createElement(Tooltip, {
                                title: (row === null || row === void 0 ? void 0 : row.FileName) || '',
                                placement: "top",
                                arrow: true
                            }, /*#__PURE__*/ React.createElement(Box, {
                                p: 1
                            }, /*#__PURE__*/ React.createElement(Link, {
                                underline: "hover",
                                variant: "button",
                                color: "text.primary",
                                sx: {
                                    display: 'inline-block',
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                onClick: function () { return handleAttachmentDownload(row); }
                            }, row === null || row === void 0 ? void 0 : row.FileName)))), /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                xs: 2
                            }, /*#__PURE__*/ React.createElement(Box, {
                                p: 1,
                                sx: {
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }
                            }, "".concat(Math.round((row === null || row === void 0 ? void 0 : row.Size) / 1000), " KB")))), /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                my: 1,
                                xs: 12,
                                container: true,
                                spacing: 0
                            }, /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                xs: 3
                            }, /*#__PURE__*/ React.createElement(Box, {
                                color: "text.secondary"
                            }, "Remarks:")), /*#__PURE__*/ React.createElement(Grid, {
                                item: true,
                                xs: true
                            }, /*#__PURE__*/ React.createElement(Tooltip, {
                                title: (row === null || row === void 0 ? void 0 : row.Remark) || '',
                                placement: "top",
                                arrow: true
                            }, /*#__PURE__*/ React.createElement(Box, {
                                mt: 1,
                                sx: {
                                    display: 'inline-block',
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }
                            }, row === null || row === void 0 ? void 0 : row.Remark)))));
                        }
                    }]
            }]
    }];
export var AdditionalInfo = [{
        type: FormItemTypes.Typography,
        name: "title",
        fontSize: "md",
        fontWeight: "strong",
        children: "Courier details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "CourierName",
                                        label: "Courier name:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "DocketNumber",
                                        label: "Docket number:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Continer",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "DispatchDate",
                                        label: "Dispatch Date:",
                                        value: "",
                                        valueGetter: function (formValues, field) {
                                            var _field$name, _field$name2;
                                            return formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-';
                                        },
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }, {
        type: FormItemTypes.ContainerItem,
        name: '',
        columnSize: 12,
        pt: 2,
        elements: [{
                type: FormItemTypes.List,
                columnSize: 12,
                name: 'Attachments',
                disableCheckboxSelection: true,
                value: null,
                columns: [{
                        field: 'ContentType',
                        maxWidth: 50,
                        renderCell: function (_ref2) {
                            var row = _ref2.row;
                            return renderIcon(row === null || row === void 0 ? void 0 : row.FileName);
                        }
                    }, {
                        field: "FileName",
                        flex: 1,
                        align: "left",
                        renderCell: function (_ref3) {
                            var value = _ref3.value, row = _ref3.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Link, {
                                underline: "hover",
                                variant: "button",
                                color: "text.primary",
                                onClick: function () { return handleAttachmentDownload(row); }
                            }, value), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text.secondary"
                            }, "Remarks:"));
                        }
                    }, {
                        field: "Size",
                        width: 465,
                        align: "left",
                        renderCell: function (_ref4) {
                            var value = _ref4.value, row = _ref4.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                sx: {
                                    alignSelf: "flex-end"
                                },
                                color: "text.secondary"
                            }, "".concat(Math.round(value / 1000), " KB")), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text",
                                sx: {
                                    fontSize: "12px"
                                }
                            }, row === null || row === void 0 ? void 0 : row.Remark));
                        }
                    }]
            }]
    }];
